import InstanceApi from "@/services/apiClient.js";
import { mapActions, mapGetters } from "vuex";
import EventBus from "@/event-bus";

export default {
  data() {
    return {
      succeed: false,
      cart: {},
      isEmptyCart: false,
      getCartResponseDate: null,
    };
  },

  mounted() {
    const apiUrlCart = `mcp/cart/get`;
    /* this.getCart(apiUrlCart); */
    EventBus.$on("remove-item-cart", () => {
      this.isEmptyCart = true;
    });
  },

  methods: {
    async getCart() {
      try {
        const response = await InstanceApi.get('mcp/cart/get/');
        
        this.setDateFromServer(response.headers.date)
        this.cart = response.data;
        if (response.data[0] === "Votre panier est vide" || response.data[0] === "No quote found") {
          this.isEmptyCart = true;
          this.succeed = true;
          return;
        }
        this.updateCurrentCartRecaps(response.data);
        this.setCurrentCartEcoTaxe(localStorage.getItem("ecoTaxe"));
        this.setCurrentCartUniverse(this.cart.mcp_universe)
        const delivery = {
          start: new Date(response.data.mcp_intervention_date),
          agencyId: response.data.mcp_agency,
          selectedDate: response.data.mcp_intervention_date,
          slotId: response.data.mcp_intervention_slot,
          selectedHours: response.data.mcp_intervention_slot,
        };

        this.setDeliveryCart(delivery);
        this.setSelectedDeliveryPostalCode(response.data.mcp_intervention_zipcode);
        this.setCheckoutInfoDataRequired({
          type: "postalcode",
          data: response.data.mcp_intervention_zipcode,
        });

        // On cart Loaded slotId is selectedHours (8h00 - 9h00)
        if(!Number.isInteger(delivery.slotId)) {
          delivery.slotId = this.getSlotId(delivery.slotId);
        }

        this.setDelivery(delivery);
        this.setPreprendCartInterventionSlots();

        //Set isRenting and Nb month
        this.setPreprendCartIsRenting((response.data.mcp_service == 'renting') ? true : false);
        this.setPreprendCartRentingNbMonths(response.data.mcp_renting_nb_months);
        //Set times slot selected for countdown
        this.setDateUpdateSlotDelivery(response.data.mcp_intervention_date_updated_at);
           

        if (response.data.customer_logged_in) {
          this.setCurrentUserIsLoggedIn(response.data.customer_logged_in);
          this.setCurrentUser(response.data.customer);
        }
        this.succeed = true;
        EventBus.$emit("getCart-succeed");

        if(this.errorMessages.length > 0) {

          let message = ""; 
          this.errorMessages.forEach(element => { message += element});

          this.$fire({
            title: "Oups",
            html: message,
            type: "error",
            showConfirmButton: true,
          });
        }

      } catch (error) {
        console.error(error);
        this.isEmptyCart = true;
      }
    },

    /**
     * Change slot hours in slot id
     * @param {String} slot 
     * @returns 
     */
    getSlotId(slot) {
      if(slot && !Number.isInteger(slot)) {
        if (slot.includes('08h')) return 1;
        if (slot.includes('12h')) return 2;
        if (slot.includes('14h')) return 4;
        if (slot.includes('18h')) return 5;
      }

      return slot;   
    },

    ...mapActions(["updateCurrentCartRecaps", "updateCurrentCartRecaps"]),
    ...mapActions(["setCheckoutInfoDataRequired", "setCheckoutInfoDataRequired"]),
    ...mapActions(["setDeliveryCart", "setDeliveryCart"]),
    ...mapActions(["setSelectedDeliveryPostalCode", "setSelectedDeliveryPostalCode"]),
    ...mapActions(["setCurrentUserIsLoggedIn", "setCurrentUserIsLoggedIn"]),
    ...mapActions(["setCurrentUser", "setCurrentUser"]),
    ...mapActions(["setCurrentCartEcoTaxe", "setCurrentCartEcoTaxe"]),
    ...mapActions(["setPreprendCartIsRenting", "setPreprendCartIsRenting"]),
    ...mapActions(["setPreprendCartRentingNbMonths"]),
    ...mapActions(["setCurrentCartUniverse"]),
    ...mapActions(["setDateUpdateSlotDelivery", "setDateUpdateSlotDelivery"]),
    ...mapActions(["setDateFromServer", "setDateFromServer"]),
    ...mapActions(["setDelivery"]),
    ...mapActions(["setPreprendCartInterventionSlots"]),
  },

  computed: {
    ...mapGetters({
      totalPrice: "getCurrentCartTotal",
      ecoTaxe: "getCurrentCartEcoTaxe",
      errorMessages: "getCurrentCartErrorMessages",
    }),
    ...mapGetters({ storeUrlPrefix: "getStoreUrlPrefix" }),
  },
};
